import { render, staticRenderFns } from "./checkbox-field.vue?vue&type=template&id=73460584"
import script from "./checkbox-field.vue?vue&type=script&lang=js"
export * from "./checkbox-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports